export const formatDate = (date: string) => {
  return new Date(date)
    .toLocaleString("en-GB", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    })
    .replace(/\/|\.|\s/g, ".");
};

export const findDateDiff = (startDate: string, endDate: string) => {
  const diffTime = new Date(endDate).getTime() - new Date(startDate).getTime();
  return Math.round(diffTime / (1000 * 60 * 60 * 24));
};
